<template>
  <!-- 发送：添加弹框 -->
  <el-dialog v-dialogDrag title="添加部门" :visible.sync="addDepShow" width="32%" class="dialogSendAddDep"
    append-to-body :close-on-click-modal="false" :close-on-press-escape="false" @close="reset">
    <div class="body">
      <!-- 左侧 -->
      <div class="left">
        <el-input v-model="filterText" placeholder="请输入部门名称" size="small" prefix-icon="el-icon-search" clearable>
        </el-input>
        <div v-show="filterText" class="searchForBox">
          <div class="title">部门</div>
          <el-tree ref="tree2" :key="dd" class="dep-tree" :data="depList" :props="defaultPropsSearchFor"
            :expand-on-click-node="false" check-strictly node-key="deptId" show-checkbox highlight-current :default-checked-keys="defaultCheckedKeys" @check-change="handleCheckChange2">
            <template #default="{ data }">
              <div class="treeContent">
                {{ data.deptName }}<div v-if="data.type === 3" :title="data.fullDeptName" class="labels">
                  ({{ data.fullDeptName }})
                </div>
              </div>
            </template>
          </el-tree>
        </div>
        <el-tree v-show="!filterText" ref="tree" :data="treeData" :props="defaultProps"
          :expand-on-click-node="false" class="filter-tree" node-key="deptId" show-checkbox
          highlight-current check-strictly :default-checked-keys="defaultCheckedKeys" @check-change="handleCheckChange"></el-tree>
      </div>

      <!-- 右侧添加 -->
      <div class="right">
        <div class="checkedTitle">已选</div>
        <div class="checkedList">
          <div v-for="item in roleSelectList" :key="item.deptId" class="member">
            <el-image :src="require('@/CommonDP/assets/org/depicon.png')"></el-image>
            <span>{{ item.deptName }}</span>
            <i class="el-icon-close" @click="cancel(item)"></i>
          </div>
        </div>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="addDepShow = false">取 消</el-button>
      <el-button size="small" type="primary" @click="backData">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import orgService from "@/CommonDP/service/org-service";
import { mapState } from "vuex";
import ElTree from "@/CommonDP/lib/tree/src/tree.vue";
import processDefinition from "@/CommonDP/service/processDefinition-service";

export default {
  components: {
    ElTree
  },
  props: {
    type: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      addDepShow: false,
      filterText: "", // 关键字
      depData: [], // 人员
      defaultProps: {
        children: "children",
        label: "deptName"
      },
      defaultPropsSearchFor: {
        children: 'childrens',
        label: 'deptName'
      },
      depList: [],
      roleSelectList: [], // 选择的
      dd: ""
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      userInfo: (state) => state.user.userInfo
    }),

    treeData() {
      return this.type === 1 ? this.depData : this.filterUser(this.depData);
    },
    defaultCheckedKeys() {
      const idArr = this.roleSelectList.map(item => {
        return item.deptId;
      });
      return idArr;
    }
  },
  watch: {
    filterText(val) {
      if (val) {
        this.getOrgKeywordList(val);
      }
    }
  },
  mounted() {
    this.getOrgList();
  },
  methods: {
    async getOrgKeywordList(val) {
      this.depList = [];
      const { data } = await processDefinition.queryOrgListByKeyword(this.enterpriseId, val);
      this.depList = data.deptList ? data.deptList : [];
    },
    // 部门
    async getOrgList() {
      const res = await orgService.getOrgTree(this.enterpriseId);
      this.depData = res.data;
    },

    // 过滤当前
    filterUser(data) {
      data.forEach((item) => {
        if (item.children) {
          item.children = this.filterUser(item.children);
        }
      });
      return data;
    },
    handleCheckChange2(data, checked, indeterminate) {
      var d = new Date();
      this.dd = d.getSeconds(); // 获取秒
      // 设置选择框状态
      data.deptId && this.$refs.tree2.setMyChecked && this.$refs.tree2.setMyChecked(data, checked, true);
      // 右边渲染列表
      const workDeptIds = this.$refs.tree2.getCheckedNodes().filter((item) => item.deptId);
      this.roleSelectList = this.unique(workDeptIds);
      this.handleCheckChange(data, checked, indeterminate);
    },
    // 多选框选中
    handleCheckChange(data, checked, indeterminate) {
      // 设置选择框状态
      data.deptId && this.$refs.tree.setMyChecked && this.$refs.tree.setMyChecked(data, checked, true);
      // 右边渲染列表
      const workDeptIds = this.$refs.tree.getCheckedNodes().filter((item) => item.deptId);
      this.roleSelectList = this.unique(workDeptIds);
    },
    // 去重
    unique(arr) {
      const res = new Map();
      return arr.filter((a) => !res.has(a.deptName) && res.set(a.deptName, 1));
    },

    // 取消选中的
    cancel(data) {
      this.$refs.tree2.setMyChecked && this.$refs.tree2.setMyChecked(data, false, true);
      this.$refs.tree.setMyChecked && this.$refs.tree.setMyChecked(data, false, true);
    },

    //  返回数据
    backData() {
      this.$emit("callback", this.roleSelectList);
      this.addDepShow = false;
    },

    // 重置
    reset() {
      this.filterText = ""; // 关键字
      this.roleSelectList.forEach((item) => {
        this.cancel(item);
      });
    }
  }
};
</script>

<style lang='scss' scoped>
.body {
  width: 100%;
  height: 450px;
  display: flex;
  justify-content: space-between;

  .left {
    width: 60%;
    height: 100%;

    .el-input {
      margin-bottom: 5px;
    }

    .filter-tree {
      height: calc(100% - 40px);
      overflow-y: auto;
    }
    .searchForBox{
      height: calc(100% - 40px);
      width: 100%;
      overflow-y: auto;
      .title{
        width: 100%;
        height: 30px;
        line-height: 30px;
        background:rgba(238, 243, 255, 0.88) ;
        color: var(--theme-color);
        padding-left: 16px;
        font-size: 14px;
      }
      .people-tree{
        /deep/ .el-tree-node__content{
          height: 100% !important;
          margin-bottom: 6px !important;
          align-items: start !important;
          padding: 3px 0px !important;
        }
        .treeContent{
          display: flex;
          align-items: flex-start;
          width: 100%;
          overflow: hidden;
          padding-right: 25px;
          flex-direction: column;
          .labels{
            font-size:12px;
            width:100%;
            white-space: pre-wrap;
            word-wrap: break-word;
            margin-top: 2px;
            text-indent: -0.3em;
            border:1px solid #F4F4F4;
            background: #F4F4F4;
            padding: 8px;
          }
        }
      }
      .dep-tree{
        .treeContent{
          font-size:14px;
          display: flex;
          align-items: flex-start;
          width: 100%;
          overflow: hidden;
          padding-right: 25px;
          flex-direction: row;
        };
        .labels{
          font-size:14px;
          color:var(--info-color)9;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width:100%;
        }
      }
    }
  }
  .right {
    width: 38%;
    height: 100%;
    padding: 0 10px;
    background: #fff;

    .checkedTitle {
      font-family: "Arial Normal", "Arial", sans-serif;
      font-size: 14px;
      line-height: 32px;
      font-weight: 400;
      color: #aaaaaa;
    }

    .checkedList {
      width: 100%;
      padding: 5px 2px;
      height: calc(100% - 40px);
      overflow-y: auto;

      .member {
        width: 100%;
        padding: 7px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;

        span {
          width: 1px;
          flex-grow: 1;
          margin-left: 10px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        i {
          cursor: pointer;
        }
      }
    }
  }
}
</style>

<style lang='scss'>
.dialogSendAddDep {
  .el-dialog {
    border-radius: 4px !important;
  }

  .el-dialog__header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .el-dialog__title {
      font-family: "PingFang SC";
      font-weight: 700;
      font-size: 18px;
      line-height: 25px;
      color: var(--key-color);
    }

    .el-dialog__headerbtn {
      position: relative;
      top: 0 !important;
      right: 0 !important;
    }
  }

  .el-dialog__body {
    padding: 10px 20px !important;
  }

  .el-dialog__footer {
    padding: 10px 20px !important;
  }
}
</style>
